module.exports = __webpack_public_path__ + "static/img/tongzhi.02a5b4ba.png";